import customValidateForm from 'root/src/client/logic/form/util/customValidateForm'
import getFormSchema from 'root/src/client/logic/form/selectors/formSchema'

export default (moduleId, submitThunk, formData) => async (dispatch, getState) => {
	const state = getState()
	const formSchema = getFormSchema(state, { moduleId })
	await customValidateForm(moduleId, formSchema, formData)
	return dispatch(submitThunk({ ...formData }))
}
